// @flow
import React from 'react'
import './styles.scss'

export class SvgWrapper extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div className='svg-wrapper'>
        <div className='text'>{this.props.text}</div>
        <object type='image/svg+xml' data={this.props.animation}>
          svg-animation
        </object>
      </div>
    )
  }
}
